import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.categories().then(setCategories).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="categories-page" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <Reveal>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-neutral-400">All Collections</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl lg:text-5xl">Categories</h1>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-neutral-500 sm:text-base">
          Every collection is edited down to the essentials — nothing filler, nothing loud.
        </p>
      </Reveal>

      {loading ? (
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="aspect-[16/9] animate-pulse rounded-2xl bg-neutral-200/70" />
          ))}
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {categories.map((cat, i) => (
            <Reveal key={cat.slug} delay={(i % 2) * 0.08}>
              <Link
                to={`/shop?category=${cat.slug}`}
                data-testid={`category-tile-${cat.slug}`}
                className="group relative block aspect-[16/9] overflow-hidden rounded-2xl img-frame"
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
                  <div>
                    <h2 className="font-heading text-xl font-bold text-white sm:text-2xl">{cat.name}</h2>
                    <p className="mt-1 text-sm text-white/60">
                      {cat.tagline}
                      {cat.item_count ? ` · ${cat.item_count} items` : ""}
                    </p>
                  </div>
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white/15 backdrop-blur transition-all duration-300 group-hover:bg-white group-hover:text-neutral-900 text-white">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      )}
    </main>
  );
}
